/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react';
import { node, object, string } from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';

import Header from '../Header';
import Footer from '../Footer';
import SEO from '../SEO';

// import '../styles/less/global-style.less';

const Layout = ({ pageTitle, data, children }) => (
  <>
    <SEO title={pageTitle} data={data} />
    <div itemScope itemType="https://schema.org/Plumber" className="wp-theme-1">
      <Header data={data} />

      <main>{children}</main>

      <Footer data={data} />
    </div>
  </>
);

Layout.propTypes = { pageTitle: string, data: object, children: node.isRequired };

Layout.defaultProps = { pageTitle: '', data: {} };

export default Layout;
